var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVehiclesInvestorsWithSelectedFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.0492,
    cy: 41.5156,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.61465,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1664,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8156,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4333,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5481,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51196 117.65C7.56645 117.65 8.42129 116.795 8.42129 115.741C8.42129 114.686 7.56645 113.831 6.51196 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5315 22.4228C75.586 22.4228 76.4408 21.5679 76.4408 20.5134C76.4408 19.459 75.586 18.6041 74.5315 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6493C118.923 18.7038 119.778 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.709 28.0596L182.742 28.0596M172.599 43.8115L172.718 37.6062M161.024 28.0596L159.472 28.0596M172.599 18.7516L172.599 6.57973M177.134 28.0596C174.15 28.0596 172.599 32.3556 172.599 32.3556C172.599 32.3556 172.122 28.0596 168.303 28.0596C170.021 28.0596 172.48 26.5083 172.718 23.4056C172.718 23.4056 172.996 25.9458 173.912 26.8663C174.676 27.6348 177.134 28.0596 177.134 28.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.3076,
    cy: 95.3469,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.566 95.3469C166.566 132.155 136.462 162.009 99.3076 162.009C62.1536 162.009 32.0493 132.155 32.0493 95.3469C32.0493 58.539 62.1536 28.6853 99.3076 28.6853C136.462 28.6853 166.566 58.539 166.566 95.3469Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.156 51.7109V61.1016H90.75V51.7109C90.75 51.5083 90.9145 51.3438 91.1172 51.3438H104.789C104.992 51.3438 105.156 51.5083 105.156 51.7109Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8359 43.6016H74.1641C73.9614 43.6016 73.7969 43.4371 73.7969 43.2344V29.5625C73.7969 29.3598 73.9614 29.1953 74.1641 29.1953H87.8359C88.0386 29.1953 88.2031 29.3598 88.2031 29.5625V43.2344C88.2031 43.4371 88.0386 43.6016 87.8359 43.6016Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.18 38.4062H101.508C101.305 38.4062 101.141 38.2417 101.141 38.0391V24.3672C101.141 24.1645 101.305 24 101.508 24H115.18C115.382 24 115.547 24.1645 115.547 24.3672V38.0391C115.547 38.2417 115.382 38.4062 115.18 38.4062Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8795 75L55.5 74.8899V66.2429C55.5 64.4757 56.9767 63 58.8517 63H131.148C133.023 63 134.5 64.4757 134.5 66.2429V74.8899L134.121 75H55.8795Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8672 112.824C99.8672 100.762 108.944 90.7811 120.625 89.3491L132.844 75.0146H56.5L85.3025 108.805V148.836C85.3025 149.896 86.4554 150.553 87.3667 150.013L102.701 140.926C103.532 140.433 104.041 139.539 104.041 138.573V126.225C101.41 122.414 99.8672 117.796 99.8672 112.824Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.445 111.824C145.445 124.486 135.181 134.75 122.52 134.75C109.858 134.75 99.5938 124.486 99.5938 111.824C99.5938 99.1627 109.858 88.8984 122.52 88.8984C135.181 88.8984 145.445 99.1627 145.445 111.824Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 102L112.5 122",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 102L132.5 122",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.722 53.7466C121.722 53.7466 121.722 53.7466 121.722 53.7466M121.722 53.7466L121.722 53.7468L121.722 53.7466M121.722 53.7466L121.722 53.7466M121.722 53.7466L121.722 53.7466M121.617 53.6863L117.547 51.3364V46.6365L121.617 44.2865L125.688 46.6365V51.3364L121.617 53.6863ZM125.792 46.6968C125.792 46.6968 125.792 46.6967 125.792 46.6966L125.792 46.6967L125.792 46.6968ZM121.513 53.7468C121.513 53.7467 121.513 53.7466 121.513 53.7465L121.513 53.7466L121.513 53.7468Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0078 54.2229V49.5229L63.078 47.173L67.1482 49.5229V54.2229L63.078 56.5728L59.0078 54.2229ZM62.9734 56.6332C62.9735 56.6331 62.9737 56.633 62.9738 56.633L62.9736 56.6331L62.9734 56.6332ZM63.1823 56.633C63.1824 56.6331 63.1826 56.6332 63.1827 56.6332L63.1825 56.6331L63.1823 56.633Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehiclesInvestorsWithSelectedFilters);
export default __webpack_public_path__ + "static/media/no-vehicles-investors-with-selected-filters.b71765f66e7b73018b2e5add8672a0c0.svg";
export { ForwardRef as ReactComponent };